import { AccessorialItem, NormalizedLoad } from 'types/Load';

// PLS load size. "FTL" is PLS's wire value; Drumkit's internal mode is TL. Convert at the PLS
// form boundary (see utils.ts) and never send "FTL" as a Drumkit mode.
export enum PlsLoadSize {
  FTL = 'FTL',
  LTL = 'LTL',
}

// Where the backend's estimate of a lane's miles came from.
export enum PlsLaneMilesSource {
  History = 'lane_history',
  MileageLookup = 'mileage_lookup',
}

export type PlsEstimatedMiles = {
  miles: number;
  source: PlsLaneMilesSource | '';
};

export type PlsOperationalFieldDefinition = {
  id: number;
  code: string;
  name: string;
};

export type PlsAccessorial = {
  id: number;
  code: string;
  name: string;
  description?: string | null;
  defaultRate?: number | null;
};

export type PlsFormAccessorialItem = AccessorialItem & {
  code?: string;
};

export type PlsReferenceFieldDefinition = {
  id: number;
  code: string;
  name: string;
  level: string;
};

export type PlsReferenceFieldPage = {
  items: PlsReferenceFieldDefinition[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
};

// A Load Reference Fields card the rep opened that has no type yet. It lives in the form so
// Build Load can stop on a number with no type instead of dropping it; create never sends it.
export type PendingReference = {
  id: number;
  value: string;
};

export type PlsFormValues = Omit<NormalizedLoad, 'accessorials'> & {
  accessorials?: PlsFormAccessorialItem[];
  plsSelectedLocationId: string;
  plsOperationalFields: Record<string, string>;
  plsLoadReferenceFields: Record<string, string>;
  plsPickupReferenceFields: Record<string, string>;
  plsConsigneeReferenceFields: Record<string, string>;
  plsLoadServiceTypeId: string;
  plsPendingReferences?: PendingReference[];
};

export type PlsReferenceFieldValues = {
  plsOperationalFields?: Record<string, string>;
  plsLoadReferenceFields?: Record<string, string>;
};

export type PlsPartitionedReferenceFields = {
  plsOperationalFields: Record<string, string>;
  plsLoadReferenceFields: Record<string, string>;
  changed: boolean;
};
